import React from 'react';

// true once the visitor has accepted cookies
const ConsentContext = React.createContext(false);

export default ConsentContext;
